
export const PRESET_COLORS = [
  '#F67672',
  '#F99A41',
  '#FAC10A',
  '#AADF8A',
  '#60D7B1',
  '#478CFF',
  '#A97BF8',
  '#F36E9F',
  '#5871B0',
  '#0076BB',
  '#D75200',
  '#D3A402',
  '#418426',
  '#465814',
  '#A65A50',
  '#CE8F6B'
];
